<template>
  <div class="register">
    <div class="register-box">
      <div class="form">
        <h2 class="user-title Medium">会员注册</h2>
        <el-form
          v-loading="loading"
          element-loading-text="注册中..."
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          label-position="top"
          class="demo-ruleForm"
        >
          <el-form-item label="用户名" prop="userName">
            <el-input
              v-model="ruleForm.userName"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input
              v-model="ruleForm.mobile"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <div class="code-box">
              <div class="code-input">
                <el-input
                  v-model="ruleForm.code"
                  placeholder="请输入短信验证码"
                ></el-input>
              </div>
              <el-button
                @click="sendMobileCode"
                :disabled="mobileLoaing"
                class="code"
                type="primary"
                round
                >{{ codeText }}</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              v-model="ruleForm.password"
              show-password
              placeholder="6-20字符，字母符号组合"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmWord">
            <el-input
              v-model="ruleForm.confirmWord"
              show-password
              placeholder="6-20字符，字母符号组合"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱（选填）" prop="email">
            <el-input
              v-model="ruleForm.email"
              placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <span @click="goLogin" class="forget">会员登录</span>
            <el-button
              @click="register"
              :disabled="loading"
              class="edit"
              type="primary"
              round
              >立即注册</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { register, sendMobileCode } from "@/request/member.js";
import { isPhone, isEmail } from "@/utils/validator";
export default {
  name: "Regiter",
  data() {
    var validateMoblie = (rule, value, callback) => {
      if (!isPhone(value)) {
        callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    };
    var validateConfirmWord = (rule, value, callback) => {
      if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    // var validateCode = (rule, value, callback) => {
    //   if (value !== this.checkCode) {
    //     callback(new Error('验证码错误!'));
    //   } else {
    //     callback();
    //   }
    // };
    var validateEmail = (rule, value, callback) => {
      if (value != "" && !isEmail(value)) {
        callback(new Error("请输入正确的邮箱!"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      mobileLoaing: false,
      //短信验证码
      checkCode: "",
      ruleForm: {
        userName: "",
        mobile: "",
        password: "",
        code: "",
        confirmWord: "",
        email: "",
      },
      codeText: "获取验证码",
      timeCount: 60,
      timer: null,
      rules: {
        userName: [
          { required: true, message: "请输入用户名", trigger: "change" },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "change" },
          { validator: validateMoblie, trigger: "change" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "change",
          },
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "change" },
          // { validator: validateCode, trigger: 'change' },
        ],
        confirmWord: [
          { required: true, message: "请再次输入密码", trigger: "change" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "change",
          },
          { validator: validateConfirmWord, trigger: "change" },
        ],
        email: [{ validator: validateEmail, trigger: "change" }],
      },
    };
  },
  methods: {
    ...mapMutations("member", ["updateUserInfo", "updataToken"]),
    goLogin() {
      this.$router.push({
        path: "/login",
      });
    },
    //发送验证码
    sendMobileCode() {
      if (!this.ruleForm.mobile) {
        this.$message({
          message: "请先输入手机号",
          type: "warning",
        });
      } else {
        sendMobileCode({
          mobile: this.ruleForm.mobile,
          type: "Register",
        })
          .then((res) => {
            if (res.response.Code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              var that = this;
              if (!that.timer) {
                that.timer = setInterval(() => {
                  if (that.timeCount > 0) {
                    that.timeCount--;
                    that.codeText = "重新发送" + that.timeCount + "s";
                    that.mobileLoaing = true;
                  } else {
                    that.codeText = "获取验证码";
                    clearInterval(that.timer);
                    that.timer = null;
                    that.timeCount = 60;
                    that.mobileLoaing = false;
                  }
                }, 1000);
              }
            } else {
              this.$message.error(res.response.Data)
            }
          })
          .catch((err) => {
            this.mobileLoaing = false;
          });
      }
    },
    //注册
    register() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          register(this.ruleForm)
            .then((res) => {
              if (res.response.Code == 200) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.updateUserInfo(res.response);
                this.updataToken(res.response.Token);
                this.loading = false;
                this.$router.push({
                  path: "/win",
                  query: { type: 1 },
                });
              } else {
                this.$message.error(res.response.Data);
                this.loading = false;
              }
            })
            .catch((err) => {
              this.loading = false;
            });
        }
      });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.register {
  width: 100%;
  background: #fff;
}
.register-box {
  width: 1200px;
  padding-top: 80px;
  margin: 0 auto;
}
.form {
  width: 400px;
  margin-left: 260px;
}
.code-box {
  width: 100%;
  display: flex;
}
.code-input {
  flex: 1;
}
.code {
  width: 120px;
  height: 40px;
  background: #2a82e4;
  display: flex;
  font-size: 16px;
  color: #fff;
  border-radius: 20px;
  align-items: center;
  justify-content: center;
  margin-left: 16px;
}
.forget {
  font-size: 14px;
  color: #2a82e4;
  cursor: pointer;
}
.edit {
  width: 100%;
  height: 48px;
  display: flex;
  background: #2a82e4;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
  font-weight: 400;
  margin-top: 20px;
  cursor: pointer;
}
</style>